import React from "react";

const Card2 = ({
  qrCodeRef,
  logo,
  profile,
  candidateName,
  studentAdmission,
  studentClass,
  studentSection,
  qrData,
  fathersName,
  schoolName,
  mobile,
  schoolMobile,
  schoolAddress,
}) => {
  return (
    <div
      ref={qrCodeRef}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="ad-card">
        <img src={logo} alt="Profile" className="ad-schoollogo" />
        <div class="row">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
              gap: "20px",
            }}
          >
            <img src={profile} alt="Profile" className="ad-student" />

            <div className="ad-details">
              <h5
                style={{
                  marginBottom: "15px",
                  fontSize: "18px",
                  fontWeight: "bold",
                  boxShadow: "0 0 4px 2px rgb(219, 219, 219)",
                  backgroundColor: "#f1ca75",
                  padding: "10px",
                  borderRadius: "8px",
                }}
              >
                {schoolName}
              </h5>
              <h6>{candidateName}</h6>
              <p>
                <strong>Admission No.:</strong>
                {studentAdmission}
              </p>
              <p>
                <strong>Father:</strong> {fathersName}
              </p>
              <p>
                <strong>Class:</strong> {studentClass} - {studentSection}
              </p>
              <p>
                <strong>Mobile:</strong> {mobile}
              </p>
            </div>
            <img
              src={qrData}
              alt="Profile"
              X
              style={{
                width: 100,
                marginTop: "10px",
              }}
            />
          </div>
        </div>
        <div class="ad-footer">
          {schoolName} | Phone: {schoolMobile}
          <br/>
          <span>{schoolAddress}</span>
        </div>
      </div>
    </div>
  );
};

export default Card2;
